import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { SideNavOuterToolbar as SideNavBarLayout } from './layouts';
import { appInfo } from './app-info';
import { appRoutes, routes } from './app-routes';
import { useTranslation } from 'react-i18next';

export const Content = () => {

  const { i18n } = useTranslation();
  const location = useLocation();

  const headerTitle = React.useMemo(() => {
    const currentRoute = routes.find(route => route.path === location.pathname);
    if (!currentRoute) {
      return appInfo().title;
    }

    const resolvedTitle = typeof currentRoute.title === 'function'
      ? currentRoute.title()
      : currentRoute.title;

    return resolvedTitle || appInfo().title;
  }, [location.pathname, i18n.language]);

  React.useEffect(() => {
    document.title = headerTitle === appInfo().title
      ? appInfo().title
      : `${appInfo().title} - ${headerTitle}`;
  }, [headerTitle]);

  return (
    <SideNavBarLayout title={headerTitle}>
      <Routes>
        {appRoutes.map(({ path, element: Element }) => (
          <Route key={path} path={path} element={<Element />} />
        ))}
        <Route path='*' element={<Navigate to='/support/dashboard' />} />
      </Routes>
    </SideNavBarLayout>
  );
};
